/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChannelUsersResponse
 */
export interface ChannelUsersResponse {
    /**
     * 
     * @type {string}
     * @memberof ChannelUsersResponse
     */
    message: string;
}

export function ChannelUsersResponseFromJSON(json: any): ChannelUsersResponse {
    return ChannelUsersResponseFromJSONTyped(json, false);
}

export function ChannelUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function ChannelUsersResponseToJSON(value?: ChannelUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}


